import view from './recover-username'
export default view
